import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  Paper,
  Rating,
} from '@mui/material';
import { motion } from 'framer-motion';
import { AutoStories, Favorite, Psychology, FormatQuote } from '@mui/icons-material';
// @ts-ignore
import coverImage from '../assets/kapak.png';

const Home: React.FC = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <AutoStories sx={{ fontSize: 40 }} />,
      title: 'Profesyonel Tarot Okumaları',
      description: 'Uzman tarot okuyucuları ile kişiselleştirilmiş, derinlemesine tarot seansları.'
    },
    {
      icon: <Psychology sx={{ fontSize: 40 }} />,
      title: 'Spiritüel Rehberlik',
      description: 'Hayatınızdaki zorlu kararlar ve dönüm noktaları için manevi rehberlik.'
    },
    {
      icon: <Favorite sx={{ fontSize: 40 }} />,
      title: 'Özel Danışmanlık',
      description: 'Aşk, kariyer ve kişisel gelişim konularında özel danışmanlık hizmeti.'
    }
  ];

  const testimonials = [
    {
      name: 'Ayşe Y.',
      comment: 'Rose Tarot ile yaptığım seans hayatıma çok farklı bir bakış açısı kattı. Profesyonel ve içten yaklaşımları için teşekkür ederim.',
      rating: 5,
      avatar: '1'
    },
    {
      name: 'Mehmet K.',
      comment: 'Kariyer konusunda yaşadığım belirsizlikte bana yol gösterdiler. Aldığım kararlardan çok memnunum.',
      rating: 5,
      avatar: '2'
    },
    {
      name: 'Zeynep A.',
      comment: 'Çok detaylı ve aydınlatıcı bir seans deneyimi yaşadım. Kesinlikle tavsiye ediyorum.',
      rating: 5,
      avatar: '3'
    }
  ];

  return (
    <>
      <Box sx={{ position: 'relative', width: '100%', height: '100vh' }}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
        >
          <Box
            component="img"
            src={coverImage}
            alt="Rose Tarot Cover"
            sx={{
              width: '100%',
              height: '100vh',
              objectFit: 'cover',
              position: 'fixed',
              top: 0,
              left: 0,
              zIndex: -1,
              filter: 'brightness(0.6)',
            }}
          />
        </motion.div>

        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'linear-gradient(180deg, rgba(26,26,46,0.2) 0%, rgba(26,26,46,0.8) 100%)',
            minHeight: '100vh',
            pt: { xs: 8, md: 0 },
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              className="gradient-text"
              sx={{
                mb: 2,
                fontSize: { xs: '2.5rem', md: '4rem' },
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              ROSE TAROT
            </Typography>
            <Typography
              variant="h5"
              sx={{
                mb: 4,
                color: 'white',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                textAlign: 'center',
              }}
            >
              Kartların rehberliğinde yolculuğunuza ışık tutuyoruz
            </Typography>
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/tarot-reading')}
                sx={{
                  borderRadius: '25px',
                  padding: '12px 48px',
                  fontSize: '1.1rem',
                  background: 'linear-gradient(45deg, #ff9a9e 30%, #fad0c4 90%)',
                  boxShadow: '0 3px 5px 2px rgba(255, 154, 158, .3)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #fad0c4 30%, #ff9a9e 90%)',
                    transform: 'scale(1.05)',
                    transition: 'all 0.3s ease-in-out',
                  }
                }}
              >
                Seans Planla
              </Button>
            </Box>
          </motion.div>
        </Box>
      </Box>

      <Container sx={{ position: 'relative', zIndex: 1, mt: { xs: 4, md: 8 } }}>
        {/* Features Section */}
        <Box sx={{ mb: 12 }}>
          <Typography
            variant="h3"
            align="center"
            className="gradient-text"
            sx={{ mb: 6 }}
          >
            Hizmetlerimiz
          </Typography>
          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                >
                  <Paper
                    elevation={3}
                    sx={{
                      p: 4,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                      background: 'linear-gradient(145deg, rgba(22, 33, 62, 0.9) 0%, rgba(26, 26, 46, 0.9) 100%)',
                      backdropFilter: 'blur(10px)',
                    }}
                  >
                    <Box sx={{ color: 'primary.main', mb: 2 }}>
                      {feature.icon}
                    </Box>
                    <Typography variant="h5" gutterBottom>
                      {feature.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {feature.description}
                    </Typography>
                  </Paper>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Testimonials Section */}
        <Box sx={{ mb: 12 }}>
          <Typography
            variant="h3"
            align="center"
            className="gradient-text"
            sx={{ mb: 6 }}
          >
            Danışan Yorumları
          </Typography>
          <Grid container spacing={4}>
            {testimonials.map((testimonial, index) => (
              <Grid item xs={12} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                >
                  <Card
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      background: 'linear-gradient(145deg, rgba(22, 33, 62, 0.9) 0%, rgba(26, 26, 46, 0.9) 100%)',
                    }}
                  >
                    <CardContent>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Avatar
                          sx={{
                            bgcolor: 'primary.main',
                            width: 56,
                            height: 56,
                            mr: 2
                          }}
                        >
                          {testimonial.name[0]}
                        </Avatar>
                        <Box>
                          <Typography variant="h6">{testimonial.name}</Typography>
                          <Rating value={testimonial.rating} readOnly />
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', mb: 2 }}>
                        <FormatQuote sx={{ color: 'primary.main', transform: 'rotate(180deg)', mr: 1 }} />
                      </Box>
                      <Typography variant="body1" color="text.secondary">
                        {testimonial.comment}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Call to Action Section */}
        <Box sx={{ mb: 12 }}>
          <Paper
            elevation={3}
            sx={{
              p: 6,
              textAlign: 'center',
              background: 'linear-gradient(145deg, rgba(22, 33, 62, 0.9) 0%, rgba(26, 26, 46, 0.9) 100%)',
              backdropFilter: 'blur(10px)',
            }}
          >
            <Typography variant="h4" className="gradient-text" gutterBottom>
              Hayatınızdaki Sorulara Cevap Bulun
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
              Profesyonel tarot okuyucularımız ile özel bir seans planlayın
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/tarot-reading')}
              sx={{
                borderRadius: '25px',
                padding: '12px 48px',
                background: 'linear-gradient(45deg, #ff9a9e 30%, #fad0c4 90%)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #fad0c4 30%, #ff9a9e 90%)',
                }
              }}
            >
              Hemen Başlayın
            </Button>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default Home; 